// extracted by mini-css-extract-plugin
export var deleteModal = "_hs-0";